module.exports = __webpack_public_path__ + "img/loading.6446a7cf.gif";